import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    cardDarlings: {
      width: '18rem',
      height: 138,
      marginLeft: 1,
      marginBottom: 1,
      marginTop: 1,
      marginRight: 10,
      borderRadius: 15,
      cursor: 'pointer',
    },
    girdTitle: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      width: '100%',
      marginBottom: '5px',
    },
    textTitle: {
      fontSize: 14,
      color: '#8c4b3e',
      margin: '0px 0px 0px 5px!important',
    },
    textTitleDarlings: {
      fontSize: 11,
      color: '#444',
      overflow: 'hidden',
      margin: '5px!important',
      height: 33,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    gridValue: {
      background: '#bd1010',
      borderRadius: 5,
      margin: '0px 10px!important',
      padding: '3px',
      display: 'flex',
    },
    iconPlusValue: {
      marginRight: 5,
    },
    textTitleDarlingsValue: {
      fontSize: 12,
      color: '#fff',
      margin: '0px!important',
    },
    imgDarlings: {
      width: 60,
      height: 60,
      borderRadius: 15,
      objectFit: 'cover',
    },
  }),
);

export default useStyles;
